<template>
  <div class="cont-box">
    <img src="../../assets/wxdj-head.png">
    <div class="cont">
      <el-form label-position="top" label-width="80px" :rules="rules" ref="subData" :model="subData">
        <el-form-item label="维修区域:" prop="fixArea">
          <el-select v-model="subData.fixArea" placeholder="请选择">
            <el-option v-for="item in areaArr" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="具体维修地点:" prop="fixPoint">
          <el-input v-model="subData.fixPoint" placeholder="例如: 4011号房间 / G栋5楼西边男卫生间"></el-input>
        </el-form-item>
        <el-form-item label="报修人与联系方式:" prop="nameAndPhone">
          <el-input v-model="subData.nameAndPhone" placeholder="格式: 联系人—联系方式"></el-input>
        </el-form-item>
        <el-form-item label="维修事项:" prop="remark">
          <el-input type="textarea" rows="4" v-model="
          subData.remark" placeholder="请描述需维修的具体项目"></el-input>
        </el-form-item>
        <el-form-item label="问题图片:" prop="file">
          <el-upload :action="axios.defaults.baseURL+'/fleUploadAndDownload/FileUpload'" v-model="subData.file"
            :file-list="fileList" :auto-upload="true" :limit="3" ref="upload" :before-upload="beforeUploadImage" :on-exceed="handleExceed"
            :on-remove="handleRemove" :on-success="handleSuccess" class="my-upload">
            <el-button type="infor">上传图片</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="isLoading" @click="submitForm('subData')" class="sub-btn">提&nbsp;&nbsp;交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'

  export default {
    data() {
      return {
        axios: axios,
        pop: true,
        fileList: [],
        isLoading: false,
        subData: {
          fixArea: '公共区域',
          fixPoint: '',
          nameAndPhone: '',
          remark: '',
          file: [],
        },
        areaArr: [
          {
            value: '公共区域',
            label: '公共区域'
          }, {
            value: '宿舍',
            label: '宿舍'
          }
        ],
        rules: {
          fixArea: [{
            required: true,
            message: '请填写',
            trigger: ['blur', 'change']
          }],
          fixPoint: [{
            required: true,
            message: '请填写',
            trigger: ['blur', 'change']
          }],
          nameAndPhone: [{
            required: true,
            message: '请填写',
            trigger: ['blur', 'change']
          }],
          remark: [{
            required: true,
            message: '请填写',
            trigger: ['blur', 'change']
          }],
          file: [{
            required: true,
            message: '请上传',
            trigger: ['blur', 'change']
          }]
        }
      }
    },
    mounted() {

    },
    methods: {
      // 判断上传的是否为图片
      beforeUploadImage(file) {
          var img = file.name.substring(file.name.lastIndexOf('.') + 1)
          const suffix = img === 'jpg'
          const suffix2 = img === 'png'
          const suffix3 = img === 'jpeg'
          // const isLt1M = file.size / 1024 / 1024 < 1;
          if (!suffix && !suffix2 && !suffix3) {
              this.$message.error("只能上传图片！");
              return false
          }
          // 可以限制图片的大小
          // if (!isLt1M) {
          //     this.$message.error('上传图片大小不能超过 1MB!');
          // }
          return suffix || suffix2 || suffix3
      },
      handleExceed(files, fileList) {
        this.$message({
          message: '超出最大上传数',
          type: 'warning',
          center: true,
          customClass: 'my-mes',
          duration: 1000
        })
      },
      handleRemove(file, fileList) {
        this.subData.file = fileList
      },
      handleSuccess(res, file, fileList) {
        this.subData.file = fileList
        this.$refs.subData.validateField('file')
      },
      formatPathArr(objArr) {
        let resultArr = []
        objArr.map( item =>{
          
          resultArr.push({fileName: item.name, filePath: item.response.data})
        })
        return resultArr
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.isLoading = true
            this.$axios.post('/PropertyServer/save', {...this.subData, file: this.formatPathArr(this.subData.file)}).then(res => {
              this.$refs[formName].resetFields()
              this.$refs.upload.clearFiles()
              this.$message({
                message: '提交成功',
                type: 'success',
                center: true,
                customClass: 'my-mes',
                duration: 1000
              })
              this.isLoading = false
            }).catch(() => {
              this.isLoading = false
            })
          } else {
            console.log('error submit!!');
            return false
          }
        })
      }
    }
  }
</script>

<style scoped>
  .cont-box {

  }

  .cont-box>img {
    width: 100%;
  }


  .el-form {
    padding: 0 2rem;
  }
  
  .el-select {
    width: 100%;
  }

  .header {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
    align-items: center;
  }

  .logo {
    width: 40%;
    padding: 2rem 0 1rem;
  }

  .title {
    width: 60%;
  }

  .title-d {
    color: #e8380d;
    padding: 0.8rem 0;
  }

  .el-form--label-top>>>.el-form-item__label {
    padding: 0;
    font-weight: bold;
  }

  .el-button {
    width: 100%;
  }

  .el-button.sub-btn {
    margin: 1rem 0 3rem;
    background: linear-gradient(#ed6404, #e8320d);
    border: none;
    font-size: 1.2rem;
    font-weight: bold;
    padding: 1rem 0;
  }
  
  .el-button.sub-btn:active {
    filter: drop-shadow(0 1px 4px #ed6404);
  }

  .el-button.pop-btn {
    width: 6rem;
    background-color: #e8320d;
    border: none;
    margin: 1rem 0 .5rem;
  }

  .pop {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, .6);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .pop-cont {
    box-sizing: border-box;
    width: 72%;
    height: 16rem;
    background: white;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 0 1rem;
  }

  .pop-cont>p:nth-of-type(1) {
    font-size: 1.2rem;
    font-weight: bold;
    margin: .5rem 0 1rem;
  }

  .pop-cont>p:nth-of-type(2) {
    color: #e8320d;
    font-size: 1.1rem;
    text-align: center;
    margin-bottom: .5rem;
  }

  .pop-cont>p:nth-of-type(3) {
    color: #646464;
    text-align: center;
    line-height: 2rem;
  }

  .der {
    padding: 0 2rem 2rem;
  }

  .der>p {
    line-height: 1.8rem;
    color: #e8320d;
  }

  .der>p>span:nth-of-type(1) {
    font-weight: bold;
  }

  .der>p:nth-of-type(2) {
    margin-top: .5rem;
    font-size: .8rem;
    color: #646464;
    line-height: 1.2rem;
  }

  .my-upload>>>.el-upload {
    width: 100%;
  }
  
  .el-input >>> .el-input__inner, .el-textarea >>> .el-textarea__inner {
    color: #323232;
  }
</style>
